import { fetchActiveTasksRequest } from 'actions/tasks';
import type { ActiveTask, Selector } from 'types';

export const getActiveTasksLoading: Selector<boolean> = (state) =>
  state.tasks.loading.includes(fetchActiveTasksRequest.toString());

export const getActiveTasks: Selector<ActiveTask[]> = (state) => state.tasks.activeTasks;
